import { IsSysAdminGuard } from './modules/guard/is-sys-admin.guard';
import { SiteLayoutComponent } from './modules/layout/components/site-layout/site-layout.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuardService } from './modules/authentication/services/authentication-guard.service';

const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule),
  },
  {
    path: 'login',
    redirectTo: 'authentication/login',
    pathMatch: 'full'
  },
  {
    path: 'user-registration',
    loadChildren: () => import('./modules/user-registration/user-registration.module').then(m => m.UserRegistrationModule),
  },
  {
    path: '',
    component: SiteLayoutComponent,
    canActivate: [AuthenticationGuardService],
    data: { preload: true },
    children: [
      // {
      //   path: '',
      //   loadChildren: () => import('./modules/site/site.module').then(m => m.SiteModule),
      //   canActivate: [AuthenticationGuardService],
      // },
      {
        path: 'reference',
        loadChildren: () => import('./modules/reference/reference.module').then(m => m.ReferencesModule),
        canActivate: [AuthenticationGuardService],
      },
      {
        path: 'user',
        loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
        canActivate: [AuthenticationGuardService]
      }
    ]
  },
  { path: '**', redirectTo: 'login' }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
